<template lang="html">

  <section class="idioma">
    <button :active="lang == 'es'" class="lang -es" @click="requestLangChange('es')">Cambiar a español</button>
    <button :active="lang == 'en'" class="lang -en" @click="requestLangChange('en')">Change to English</button>
  </section>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  export default  {
    name: 'idioma',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
      ...mapActions(['changeLanguage']),
      requestLangChange : function(lang){
        this.changeLanguage(lang)
        .then(r => {
          this.$i18n.locale = r;
          // this.changePath(); 
        }).catch(e =>{
          console.log(e);
        })
      },
    },
    computed: {
      ...mapGetters({
        lang : 'getLanguage'
      })
    }
  }
</script>

<style scoped lang="scss">
.idioma {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/footer/idioma.vue